export const Page = {
  baseStyle: {
    padding:
      '0px' /*
              0px because some elements should be tight up against the page.
              Note that things inside the page should cause visual padding of '48px 64px'
            */,
    margin: '0px auto 20px auto',
    maxWidth: '960px',
    background: 'brand.white',
    color: 'brand.black',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.12)',
    borderRadius: '6px',
  },
};
